import {
  BookingVerificationStatusTypeEnum,
  N0BookingVerificationRequest,
  N0CompleteBookingVerificationResponse,
  N0VerificationResponse,
  VerifyRequest,
} from '@models/sms-validation.model';
import { createAction, props } from '@ngrx/store';

export const enum SmsVerificationActionTypes {
  verifyBookingChange = '[smsVerification] VERFIY_BOOKING_CHANGE',
  verifyBookingChangeResponse = '[smsVerification] VERFIY_BOOKING_CHANGE_RESPONSE',
  verifyBookingChangeComplete = '[smsVerification] VERIFY_BOOKING_CHANGE_COMPLETE',
  verifyBookingChangeCompleteSuccess = '[smsVerification] VERIFY_BOOKING_CHANGE_COMPLETE_SUCCESS',
  getBookingVerificationStatus = '[smsVerification] GET_BOOKING_VERIFICATION_STATUS',
  getBookingVerificationStatusSuccess = '[smsVerification] GET_BOOKING_VERIFICATION_STATUS_SUCCESS',
}

export const smsVerificationVerifyBookingChange = createAction(
  SmsVerificationActionTypes.verifyBookingChange,
  props<{ request: N0BookingVerificationRequest }>(),
);

export const smsVerificationVerifyBookingChangeResponse = createAction(
  SmsVerificationActionTypes.verifyBookingChangeResponse,
  props<{ response: N0VerificationResponse }>(),
);

export const smsVerificationVerifyBookingChangeComplete = createAction(
  SmsVerificationActionTypes.verifyBookingChangeComplete,
  props<{ payload: VerifyRequest }>(),
);

export const smsVerificationVerifyBookingChangeCompleteSuccess = createAction(
  SmsVerificationActionTypes.verifyBookingChangeCompleteSuccess,
  props<{ response: N0CompleteBookingVerificationResponse }>(),
);

export const smsVerificationGetBookingVerificationStatus = createAction(
  SmsVerificationActionTypes.getBookingVerificationStatus,
);

export const smsVerificationGetBookingVerificationStatusSuccess = createAction(
  SmsVerificationActionTypes.getBookingVerificationStatusSuccess,
  props<{ status: BookingVerificationStatusTypeEnum }>(),
);
